import * as login from './modules/login'
import * as home from './modules/home'
import * as userManager from './modules/userManager'
import * as courseManager from './modules/courseManager'
import * as uploadManager from './modules/uploadManager'
import * as cloudDisk from './modules/cloudDisk'
import * as liveServer from './modules/liveServer'
import * as recharge from './modules/recharge'
import * as adminMessage from './modules/adminMessage'
import * as userInfo from './modules/userInfo'
export default {
  login,
  home,
  userManager,
  courseManager,
  uploadManager,
  cloudDisk,
  liveServer,
  recharge,
  adminMessage,
  userInfo
}



// WEBPACK FOOTER //
// ./src/http/api.js